"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ManageTextField = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Provides a wrapper to a TextField component that can be used on the Manage Memberships tab. The text fields have consistent styling and
 * properties. 
 *    
 * The text can be set directly by the parent (who must hold a reference to the component) by calling set().  This sets the
 * text and clears the background color.  Calling reset() clears the background color and sets the text to the text previously set by a
 * call to set().  Calling accept() calls set() with the current text.
 * 
 * When the text is edited, it turns pale blue.  When the enter key is pressed, focus is lost. 
 * 
 * When focus is lost (either through enter key or click away), a callback is called.
 * 
 * The caller must supply three props:
 * 
 * label: (*) the label for the field (String)
 * json:   a key to identify the field, passed back to the focus lost callback.  If null, field is read only
 * onFieldChange: the callback function called when focus is lost, called with two parameters: the json key prop, and the changed text value
 * 
 * 
 * The caller may supply the optional props:
 * 
 * isReadOnly:(*) set as read only. If not supplied, it is not read only unless otherwise restricted per "editable" param
 * editable:      if the user has permissions to edit the field (otherwise read only), default true
 * multiline: (*) a positive value for multiline text or 0 for single line.  If not supplied, default is 0.  The value is the number of lines to display
 * fullWidth: (*) true to set full width, default true
 * textAlign: alignment of text (default: left)
 * fontSize:  size of the text font
 * initialValue: initial text, if not supplied, use empty text.  User can also call set() directly with reference
 * autoCommit: commit changes immediately on any change, default FALSE
 * autoAccept: accept changes on enter/blur, default FALSE
 * changedBackgroundColor: color to set the background on change, default PaleBlue
 * style:      override the props.style for the text field, for subclasses
 * tooltip: optional tooltip for the text field
 * 
 *   (*) = indicates field can be changed after component init
 *  
 */

var PaleBlueColor = '#E6FAFF';
var ManageTextField = exports.ManageTextField = /*#__PURE__*/function (_Component) {
  function ManageTextField(props) {
    var _this;
    _classCallCheck(this, ManageTextField);
    _this = _callSuper(this, ManageTextField, [props]);
    _defineProperty(_this, "styles", {
      container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        padding: 0
      }
    });
    _defineProperty(_this, "state", {
      text: "",
      //current text value
      color: 'white' //current background color
    });
    _defineProperty(_this, "_isEditable", void 0);
    _defineProperty(_this, "_json", void 0);
    _defineProperty(_this, "_fieldChanged", void 0);
    _defineProperty(_this, "_initialText", "");
    //default - empty string
    _defineProperty(_this, "_textAlign", "left");
    _defineProperty(_this, "_doCallback", false);
    _defineProperty(_this, "_autoCommit", false);
    _defineProperty(_this, "_autoAccept", false);
    _defineProperty(_this, "_changedBackgroundColor", PaleBlueColor);
    _defineProperty(_this, "_style", void 0);
    _defineProperty(_this, "_tooltip", "");
    _defineProperty(_this, "_inputRef", void 0);
    _defineProperty(_this, "setFocus", function () {
      if (_this._inputRef) _this._inputRef.focus();
    });
    /**
     * Change the text, as if the user had typed it
     */
    _defineProperty(_this, "change", function (newText) {
      var commit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (newText !== _this._initialText) {
        _this.setState({
          text: newText,
          color: _this._changedBackgroundColor
        });
        _this._doCallback = true;
      } else {
        _this.setState({
          text: newText,
          color: 'white'
        });
        _this._doCallback = false;
      }
      if (commit) _this.commit(newText);
    });
    _defineProperty(_this, "reset", function () {
      _this.setState({
        text: _this._initialText,
        color: 'white'
      });
      _this._doCallback = false;
    });
    _defineProperty(_this, "_keyDown", function (event) {
      if (event.key === 'Enter' && !_this.props.multiline) {
        //enter key - lose focus (only if not multiline)
        event.target.blur();
      } else if (event.key === 'Escape') {
        //set to initial text
        _this.setState({
          text: _this._initialText,
          color: 'white'
        });
        _this._doCallback = false;
        event.target.blur();
      }
    });
    //Just reflect the field value from what is entered, optionally commit immediately
    _defineProperty(_this, "_fieldModified", function (event) {
      var newText = event.target.value;
      _this.change(newText);
      if (_this._autoCommit) _this.commit(newText);
    });
    _defineProperty(_this, "_onBlur", function () {
      try {
        _this.commit(_this.state.text);
      } catch (error) {
        console.log(error);
        return; //do not auto accept on error
      }
      _this.autoAcceptIfNeeded();
    });
    _defineProperty(_this, "autoAcceptIfNeeded", function () {
      if (_this._autoAccept) setTimeout(function () {
        return _this.accept();
      }, 1); //defer, to allow commits
    });
    _defineProperty(_this, "_isReadOnly", function () {
      return !_this._isEditable || !_this._json || _this.props.isReadOnly;
    });
    _this._isEditable = props.editable != null ? props.editable : true;
    _this._style = props.style; //default
    _this._textAlign = props.textAlign;
    _this._fontSize = props.fontSize;
    _this._json = props.json;
    _this._fieldChanged = props.onFieldChange;
    if (props.tooltip) _this._tooltip = props.tooltip;
    _this.set = _this.set.bind(_this);
    _this.get = _this.get.bind(_this);
    _this.commit = _this.commit.bind(_this);
    _this.accept = _this.accept.bind(_this);
    if (props.initialValue) {
      _this.state.text = props.initialValue;
      _this._initialText = props.initialValue;
    }
    if (props.autoCommit) _this._autoCommit = props.autoCommit;
    if (props.autoAccept) _this._autoAccept = props.autoAccept;
    if (props.changedBackgroundColor) {
      _this._changedBackgroundColor = props.changedBackgroundColor;
    }
    return _this;
  }

  /**
   * Using the traditional way (with binding) in order to call from subclass
   * 
   * Call to set the text, and change background white
   * Also sets the initial text to the text
   * @param {String} newText to set 
   */
  _inherits(ManageTextField, _Component);
  return _createClass(ManageTextField, [{
    key: "set",
    value: function set(newText) {
      var newTextString = newText ? newText : "";
      this._initialText = newTextString;
      this._doCallback = false;
      this.setState({
        text: newTextString,
        color: 'white'
      });
    }
  }, {
    key: "get",
    value: function get() {
      return this.state.text;
    }
  }, {
    key: "accept",
    value:
    /**
     * Call to accept the text, and change background white
     */
    function accept() {
      this._initialText = this.state.text;
      this._doCallback = false;
      this.setState({
        color: 'white'
      });
    }
  }, {
    key: "commit",
    value: function commit(text) {
      var _this2 = this;
      if (this._fieldChanged && this._doCallback) setTimeout(function () {
        return _this2._fieldChanged(_this2._json, text);
      }, 1); //defer, to allow re-render
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var textStyle = {
        textAlign: this._textAlign,
        backgroundColor: this.state.color
      };
      if (this._fontSize) textStyle = _objectSpread(_objectSpread({}, textStyle), {}, {
        fontSize: this._fontSize
      });
      return /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
        title: this._tooltip
      }, /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          width: '100%',
          display: 'flex'
        }
      }, /*#__PURE__*/_react["default"].createElement(_core.TextField, {
        label: this.props.label,
        multiline: this.props.multiline > 0 ? true : false,
        rows: this.props.multiline ? this.props.multiline : 1,
        variant: "outlined",
        size: "small",
        value: this.state.text,
        inputRef: function inputRef(field) {
          return _this3._inputRef = field;
        },
        fullWidth: this.props.fullWidth ? this.props.fullWidth : true,
        inputProps: {
          readOnly: this._isReadOnly(),
          style: textStyle
        },
        onChange: this._fieldModified,
        onKeyDown: this._keyDown,
        onBlur: this._json && !this.props.isReadOnly ? this._onBlur : null,
        InputLabelProps: {
          shrink: true
        },
        style: this._style
      })));
    }
  }]);
}(_react.Component);